import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ParametersState } from './parameter-by-detail.reducer';

export const selectParametersState = createFeatureSelector<ParametersState>('parametersDetail');

export const selectRequestedParameters = createSelector(selectParametersState, (state) => state?.requested);

export const selectParameterDetails = createSelector(selectParametersState, (state) => state?.response);

export const selectParametersLoading = createSelector(selectParametersState, (state) => state?.isLoading);

export const selectParametersError = createSelector(selectParametersState, (state) => state?.error);
